module.exports = __webpack_public_path__ + "static/media/close.9644b55e.svg";